import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import { formatDate, formatTime } from "../../../utils/dateTimeUtils";
import { handleCheckoutAction, handleCheckinAction } from "../Utils/ReservationActionHelper";

export default function ConfirmCheckOutOrIn({ data, type, handleReservation }) {
    const [currentDate, setCurrentDate] = useState("");
    const [currentTime, setCurrentTime] = useState("");

    useEffect(() => {
        const updateDateTime = () => {
            const now = new Date();

            setCurrentDate(formatDate(now));
            setCurrentTime(formatTime(now));
        };

        // Initial call to set values
        updateDateTime();

        // 1000 = 1 second
        const intervalId = setInterval(updateDateTime, 1000);

        // Cleanup interval on component unmount
        return () => clearInterval(intervalId);
    }, []);

    const handleAction = () => {
        if (type === 'checkOut') {
            handleCheckoutAction(data, handleReservation);
        } else if (type === 'checkIn') {
            handleCheckinAction(data, handleReservation);
        }
    };

    return (
        <>
            <hr />
            <h3 style={{ margin: "20px" }}>
                {type === "checkOut" ? (
                    <>
                        Current Check-Out:<br />
                        Date: {currentDate}<br />
                        Time: {currentTime}
                    </>
                ) : (
                    <>
                        Current Check-In:<br />
                        Date: {currentDate}<br />
                        Time: {currentTime}
                    </>
                )}
            </h3>
            <Button
                variant="contained"
                color="primary"
                onClick={handleAction}
                style={{ marginTop: "20px" }}
            >
                {type === "checkOut" ? "Confirm Check-Out" : "Confirm Check-In"}
            </Button>
        </>
    );
}
